/** 
 * Created by anthony on 6/24/14.
 */

var fmThresholds = angular.module('fmThresholds', ['familyModel']);
fmThresholds.factory('FmThresholdsModelFactory', function(ApplicationService, AbstractModelService, FamilyModelFactory){
    var FmThresholdsModel = function(familyID){
        this.endpoint = "/FamilyThresholds";
        this.dataProperty = "thresholds";
        this.familyID = familyID;
    }
    FmThresholdsModel.prototype = new FamilyModelFactory();
    FmThresholdsModel.prototype.parent = FamilyModelFactory.prototype;
	FmThresholdsModel.prototype.put = function(id, data, instance)
    {
        return AbstractModelService.put("/api/family/" + this.familyID + "/FamilyThresholds/" + id, data, instance);
    }
    return FmThresholdsModel;

});
